import { createContext, useContext } from 'react';

// Action types
export const ACTIONS = {
    SET_IS_EDIT: 'SET_IS_EDIT',
    SET_EDIT_GROUP_INSTANCE: 'SET_EDIT_GROUP_INSTANCE',
    TOGGLE_EDIT: 'TOGGLE_EDIT',
    CLEAR_EDIT_GROUP_INSTANCE: 'CLEAR_EDIT_GROUP_INSTANCE',
    SET_ADD_MODEL_DRAWER: 'SET_ADD_MODEL_DRAWER',
    SET_ADD_DATES_DRAWER: 'SET_ADD_DATES_DRAWER',
    SET_ADD_COMMENT_FOR_EVENT: 'SET_ADD_COMMENT_FOR_EVENT',
};

// Reducer
export function followUpReducer(state, action) {
    switch (action.type) {
        case ACTIONS.SET_IS_EDIT:
            return { ...state, isEdit: action.payload };
        case ACTIONS.SET_EDIT_GROUP_INSTANCE:
            return { ...state, editGroupInstance: action.payload };
        case ACTIONS.TOGGLE_EDIT:
            return { ...state, isEdit: !state.isEdit };
        case ACTIONS.CLEAR_EDIT_GROUP_INSTANCE:
            return { ...state, editGroupInstance: undefined };
        case ACTIONS.SET_ADD_MODEL_DRAWER:
            return { ...state, showAddModelDrawer: action.payload };
        case ACTIONS.SET_ADD_DATES_DRAWER:
            return { ...state, showAddDatesDrawer: action.payload };
        case ACTIONS.SET_ADD_COMMENT_FOR_EVENT:
            return { ...state, addCommentForEventId: action.payload };
        default:
            return state;
    }
}

// Context per lo stato (cambia frequentemente)
export const FollowUpStateContext = createContext();

// Context per dispatch (stabile, non causa re-render)
export const FollowUpDispatchContext = createContext();

export function useFollowUpState() {
    return useContext(FollowUpStateContext);
}

export function useFollowUpDispatch() {
    return useContext(FollowUpDispatchContext);
}

// Shortcut per entrambi
export function useFollowUp() {
    return {
        ...useFollowUpState(),
        dispatch: useFollowUpDispatch(),
    };
}

// Manteniamo per retrocompatibilità temporanea
export function useFollowUpContext() {
    return useFollowUp();
}
